import Decimal from 'decimal.js';

const VAT_RATE = 19;

export const calculateNetto = (
  bruttoPrice: number,
  usesVat: boolean
): number => {
  if (!usesVat) {
    return bruttoPrice;
  }

  const bruttoDec = new Decimal(bruttoPrice);
  const taxRateDec = new Decimal(VAT_RATE).div(100);

  const nettoDec = bruttoDec
    .div(new Decimal(1).plus(taxRateDec))
    .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

  return nettoDec.toNumber();
};
